import {ReactNode, Suspense} from 'react';
import { Spin } from 'antd';

interface SuspenseWrapperProps {
  children: ReactNode;
}

const SuspenseWrapper = (props: SuspenseWrapperProps) => {
  return (
    <Suspense 
      fallback={
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          gap: '16px'
        }}>
          <Spin size="large" tip="Cargando aplicación..." />
        </div>
      }
    >
      {props.children}
    </Suspense>
  );
};

export default SuspenseWrapper;
